import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { HiMenu, HiX } from "react-icons/hi";

const Header = ({ appName = 'IntelServe' }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [user, setUser] = useState(null);

  // Check login status on component mount
  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    
    if (token && userData) {
      setUser(JSON.parse(userData));
    }
  }, []);

  // Helper to determine the correct dashboard path based on role
  const getDashboardPath = () => {
    if (!user || !user.roleName) return "/dashboard";

    switch (user.roleName) {
      case "super_admin": return "/dashboard/super_admin";
      case "admin": return "/dashboard/admin";
      case "case_manager": return "/dashboard/case-manager";
      case "field_agent": return "/dashboard/field-agent";
      case "client": return "/dashboard/client";
      case "servers": return "/dashboard/server";
      default: return "/dashboard";
    }
  };

  return (
    <header className="w-full bg-white border-b shadow-sm px-4 py-3">
      <div className="max-w-[1180px] mx-auto flex items-center justify-between">

        {/* Logo */}
        <Link to="/">
          <h1 className="text-3xl sm:text-5xl font-bold text-sky-600">{appName}</h1>
        </Link>

        {/* Desktop Menu */}
        <div className="hidden sm:flex gap-3">
          <Link
            to="/docs"
            className="px-6 py-2 bg-sky-700 text-white font-semibold rounded-lg shadow hover:bg-blue-700 transition"
          >
            Documentation
          </Link>

          {user ? (
            // SHOW DASHBOARD IF LOGGED IN
            <Link
              to={getDashboardPath()}
              className="px-6 py-2 bg-green-600 text-white font-semibold rounded-lg shadow hover:bg-green-700 transition"
            >
              Dashboard
            </Link>
          ) : (
            // SHOW LOGIN IF NOT LOGGED IN
            <Link
              to="/login"
              className="px-6 py-2 bg-sky-700 text-white font-semibold rounded-lg shadow hover:bg-blue-700 transition"
            >
              Log In
            </Link>
          )}
        </div>

        {/* Mobile Menu Icon */}
        <button
          className="sm:hidden text-3xl text-sky-700"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <HiX /> : <HiMenu />}
        </button>
      </div>

      {/* Mobile Dropdown Menu */}
      {menuOpen && (
        <div className="sm:hidden mt-3 flex flex-col gap-3 animate-fade-in">
          <Link
            to="/docs"
            onClick={() => setMenuOpen(false)}
            className="px-4 py-2 bg-sky-700 text-white rounded-lg shadow hover:bg-blue-700 transition"
          >
            Documentation
          </Link>

          {user ? (
            // MOBILE DASHBOARD LINK
            <Link
              to={getDashboardPath()}
              onClick={() => setMenuOpen(false)}
              className="px-4 py-2 bg-green-600 text-white rounded-lg shadow hover:bg-green-700 transition"
            >
              Dashboard
            </Link>
          ) : (
            // MOBILE LOGIN LINK
            <Link
              to="/login"
              onClick={() => setMenuOpen(false)}
              className="px-4 py-2 bg-sky-700 text-white rounded-lg shadow hover:bg-blue-700 transition"
            >
              Log In
            </Link>
          )}
        </div>
      )}
    </header>
  );
};

export default Header;